import React, { useMemo } from "react";
import { useStaticData } from "@hooks";
import { Product } from "@models";
import CategoriesSelection from "../../../products/components/configuration/CategoriesSelection";
import { Container } from "../StyledComponents";

export default function ModuleCategorySettings() {
	const { products } = useStaticData();

	const productsWithCategories = useMemo(
		// For now only Mobility is configurable
		() => products.filter((p: Product) => p.id === "mobility"),
		[products]
	);

	return (
		<Container>
			<h4>Module</h4>
			{productsWithCategories.map((product) => (
				<div key={product.id} style={{ marginBottom: "2rem" }}>
					<h5>{product.name}</h5>
					{product
						.variantOfId(product.id === "mobility" ? "combined" : "default")
						.budgetCategories.map((root) => (
							<div key={root.id} style={{ marginTop: "0.75rem" }}>
								<CategoriesSelection
									productId={product.id}
									budgetCategory={root}
								/>
							</div>
						))}
				</div>
			))}
		</Container>
	);
}
